import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, Suspense as _Suspense } from "vue"

import { t } from '@/plugins/i18n'
import { ref, watch, reactive } from 'vue'
import { getAdtList } from '@/apis/addition'
import DeliAdt from '@/components/additional/DeliAdt.vue'
import { ElMessage } from 'element-plus'
import { getAdditionalLabel } from '@/apis/inShipping'
import { getDeli } from '@/util/calcAdt'
import AdditionDrawer from '@/components/additional/AdditionDrawer.vue'
import { getWarehouseCode } from '@/store'
import { COUNTRY } from '@/global'

// defaultLabel 需要默认选择贴标附加项

export default /*#__PURE__*/_defineComponent({
  props: ['isOversea', 'isMark', 'additionalList', 'calRule', 'countryCode', 'defaultLabel', 'hiddenRMB'],
  emits: ['update:additionalList'],
  setup(__props, { emit }) {

const props = __props



const mustAdditionIdList:any = ref([])
const getDictApi = () => {
  return new Promise<void>(resolve => {
    getAdditionalLabel().then((res) => {
      (res.data || []).forEach((e: { dictKey: string | number; dictValue: any; }) => {
        additionalLabelDict.value[e.dictKey] = e.dictValue?.split(',')?.[0]
      })
      resolve()
    })
  })
}

const getAdtApi = () => {
  return new Promise<void>(resolve => {
    getAdtList({
      productType: 1,
      warehouseCode: getWarehouseCode(props.countryCode === COUNTRY.KR)
    }).then(
      (res) => {
        adtList.value = res.data.deliveryAdditionList.map((e: any) => ({
          ...e,
          ingredientsCount: 1,
          ingredientsSku: ''
        }))
        resolve()
      }
    )
  })
}

const setAdtApi = () => {
  Promise.all([getDictApi(), getAdtApi()]).then(() => {
    setAdt()
  })
}

setAdtApi()

const showAdt: any = ref(false)
const proxy: any = ref(null)
const selectAdtList: any = ref(props.additionalList)
const openAdt = () => {
  proxy.value = selectAdtList.value
  showAdt.value = true
  console.log(showAdt.value)
}
const calRule = ref(props.calRule)
const handleAdt = () => {
  setTimeout(() => {
    showAdt.value = false
  }, 500)
  if (calRule.value && !hasDefaultAddtion(proxy.value)) {
    ElMessage.warning(t('无法取消附加项'))
    return
  }
  selectAdtList.value = proxy.value
  emit('update:additionalList', selectAdtList.value)
}
const hasDefaultAddtion = (val: any) => {
  let boo = true
  const defaultData = Object.values(additionalLabelDict.value)
  defaultData.forEach((item: any) => {
    boo = boo && val.some((i: any) => String(i.additionCode) === item)
  })
  return boo
}

const adtList: any = ref([])
const additionalLabelDict: any = ref({})
const hasLabelAdditionId = () => !!additionalLabelDict.value?.need_label_delivery_addition_id && (adtList.value.length > 0)
const hasMarkAdditionId = () => !!additionalLabelDict.value?.need_mark_delivery_addition_id && (adtList.value.length > 0)

const setAdt = async () => {
  if (selectAdtList.value?.length === 0) {
    await getDeli(getWarehouseCode(props.countryCode === COUNTRY.KR)).then((res: any) => {
      res.forEach((v: any) => {
        if (!selectAdtList.value.some((v2:any) => v2.additionCode === v.additionCode)) {
          selectAdtList.value.push(v)
        }
      })
    })
  }
  if (props.isOversea || props.defaultLabel) setLabel()
  if (props.isMark) setMark()
}

const setMark = () => {
  if (hasMarkAdditionId()) {
    const hasSelectAddition = selectAdtList.value.findIndex((e: { additionCode: any; }) => String(e.additionCode) === additionalLabelDict.value.need_mark_delivery_addition_id)
    if (hasSelectAddition === -1) {
      const selAddition = adtList.value.find((e: { additionCode: any; }) => String(e.additionCode) === additionalLabelDict.value.need_mark_delivery_addition_id)
      if (selAddition) {
        mustAdditionIdList.value.indexOf(selAddition.additionCode) === -1 && mustAdditionIdList.value.push(String(selAddition.additionCode))
        selectAdtList.value.push(selAddition)
      } else {
        ElMessage.warning(t('附加项未配置箱唛'))
      }
    }
  }
}
const setLabel = () => {
  if (hasLabelAdditionId()) {
    const hasSelectAddition = selectAdtList.value.findIndex((e: { additionCode: any; }) => String(e.additionCode) === additionalLabelDict.value.need_label_delivery_addition_id)
    if (hasSelectAddition === -1) {
      const selAddition = adtList.value.find((e: { additionCode: any; }) => String(e.additionCode) === additionalLabelDict.value.need_label_delivery_addition_id)
      if (selAddition) {
        if (!props.defaultLabel) {
          mustAdditionIdList.value.indexOf(selAddition.additionCode) === -1 && mustAdditionIdList.value.push(String(selAddition.additionCode))
        }
        selectAdtList.value.push(selAddition)
      } else {
        ElMessage.warning(t('附加项未配置贴标签'))
      }
    }
  }
}

watch(() => props.isOversea, (newValue) => {
  if (newValue) setLabel()
})

watch(() => props.isMark, (newValue) => {
  if (newValue) setMark()
})


return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectAdtList.value, (addition) => {
        return (_openBlock(), _createBlock(_component_el_tag, {
          key: addition.additionCode,
          class: "tag-style"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(addition.additionNameJp ?? ''), 1)
          ]),
          _: 2
        }, 1024))
      }), 128)),
      _createVNode(_component_el_button, {
        style: {"margin-left":"10px"},
        onClick: openAdt
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('编辑')), 1)
        ]),
        _: 1
      })
    ]),
    (_openBlock(), _createBlock(_Suspense, null, {
      default: _withCtx(() => [
        (showAdt.value)
          ? (_openBlock(), _createBlock(AdditionDrawer, {
              key: 0,
              cfg: proxy.value,
              "onUpdate:cfg": _cache[0] || (_cache[0] = ($event: any) => ((proxy).value = $event)),
              onClose: handleAdt,
              type: "DeliAdt",
              mustAdditionId: mustAdditionIdList.value,
              countryCode: __props.countryCode,
              hiddenRMB: __props.hiddenRMB
            }, null, 8, ["cfg", "mustAdditionId", "countryCode", "hiddenRMB"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }))
  ], 64))
}
}

})